import { render } from "./TableDetailPanel.vue?vue&type=template&id=3f4c3516&scoped=true"
import script from "./TableDetailPanel.vue?vue&type=script&lang=js"
export * from "./TableDetailPanel.vue?vue&type=script&lang=js"

import "./TableDetailPanel.vue?vue&type=style&index=0&id=3f4c3516&scoped=true&lang=css"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f4c3516"]])

export default __exports__